// Función para formatear las fechas al formato "Jue 15/Feb, 13:10".
export const formatDate = (dateString) => {
    const date = new Date(dateString); // Parsear la cadena de fecha.
    
    const options = {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
        hour12: false // Usar formato de 24 horas
    };

    const formattedDate = date.toLocaleString('es-ES', options); // Cambiar 'es-ES' por la localidad deseada
    return formattedDate;
}
